const updates = [
  {
    id: 1,
    time: '10分钟前',
    title: '某当红小生深夜发长文疑似回应恋情传闻，粉丝解读暗藏玄机',
    tag: '最新',
    tagColor: 'bg-primary-500',
  },
  {
    id: 2,
    time: '28分钟前',
    title: '综艺节目组官方发文致歉，承认录制现场管理不当并承诺整改',
    tag: '跟进',
    tagColor: 'bg-accent-500',
  },
  {
    id: 3,
    time: '45分钟前',
    title: '知名编剧社交媒体发文暗讽某流量明星，引发双方粉丝激烈互撕',
    tag: '突发',
    tagColor: 'bg-primary-500',
  },
  {
    id: 4,
    time: '1小时前',
    title: '某女星工作室发布律师函，否认偷税漏税传闻并将追究造谣者法律责任',
    tag: '回应',
    tagColor: 'bg-secondary-500',
  },
  {
    id: 5,
    time: '2小时前',
    title: '热门电视剧剧组被曝拖欠群演工资，制片人回应称系第三方公司问题',
    tag: '爆料',
    tagColor: 'bg-accent-500',
  },
  {
    id: 6,
    time: '3小时前',
    title: '某歌手宣布无限期退出娱乐圈，粉丝后援会紧急发布联合声明',
    tag: '重磅',
    tagColor: 'bg-primary-500',
  },
  {
    id: 7,
    time: '4小时前',
    title: '短视频平台批量封禁违规网红账号，涉及虚假宣传和低俗内容',
    tag: '快讯',
    tagColor: 'bg-secondary-500',
  },
  {
    id: 8,
    time: '5小时前',
    title: '某品牌代言人更换引发讨论，网友分析背后商业博弈和市场策略',
    tag: '分析',
    tagColor: 'bg-accent-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium mb-3">
              <i className="ri-timer-flash-line"></i>
              实时动态
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
              最新快讯
            </h2>
          </div>
          <div className="flex items-center gap-1 text-xs text-foreground-500">
            <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
            实时更新中
          </div>
        </div>

        <div className="max-w-4xl mx-auto">
          {updates.map((item, idx) => (
            <a
              key={item.id}
              href="#"
              className={`flex items-start gap-4 py-4 group cursor-pointer ${
                idx < updates.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <div className="flex-shrink-0 w-20 text-right">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
              </div>
              <div className="hidden sm:block flex-shrink-0 relative mt-1">
                <div className="w-2.5 h-2.5 rounded-full border-2 border-primary-300 bg-background-50 group-hover:bg-primary-500 group-hover:border-primary-500 transition-colors" />
                {idx < updates.length - 1 && (
                  <div className="absolute top-3 left-1/2 -translate-x-1/2 w-px h-full bg-background-200" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className={`text-xs px-2 py-0.5 rounded-full text-background-50 font-medium whitespace-nowrap ${item.tagColor}`}>
                    {item.tag}
                  </span>
                </div>
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                  {item.title}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}